'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes';

/**
 * ThemeProvider component using next-themes library
 * Configures theme options and provides theme state to the application
 *
 * @component
 * @param {ThemeProviderProps} props - The component props from next-themes
 * @returns {JSX.Element} The provider component wrapping children
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}

